import { Box, Container, Typography } from "@mui/material";
import { motion } from "motion/react";
const logo = "/img/logo.png";
const computadora = "/img/computercerdito.png";
const bgHome = "/img/backgroundsection1.png";


const Section1 = () => {

    return (
        <Box
            sx={{
                minHeight: "100vh",
                backgroundImage: `url(${bgHome})`,
                backgroundSize: "cover",
                backgroundPosition: "center bottom",
                backgroundRepeat: "no-repeat",
                display: "flex",
                alignItems: "center",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: {
                            xs: "column",
                            md: "row",
                        },
                        alignItems: "center",
                        justifyContent: "space-between",
                        minHeight: "100vh",
                        gap: {
                            xs: 4,
                            md: 8,
                        },
                        py: {
                            xs: 8,
                            md: 0,
                        },
                    }}
                >
                    {/* IZQUIERDA */}
                    <Box
                        component={motion.div}
                        initial={{ opacity: 0, x: -80 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{
                            duration: 0.8,
                        }}
                        sx={{
                            flex: 1,
                            maxWidth: 550,
                        }}
                    >
                        <Box
                            component="img"
                            src={logo}
                            alt="Ready Cash"
                            sx={{
                                width: 220,
                                mb: 4,
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#517950",
                                fontWeight: 300,
                                lineHeight: 1.15,
                                textAlign: {
                                    xs: "center",
                                    md: "left",
                                },
                                fontSize: {
                                    xs: "2rem",
                                    sm: "2.8rem",
                                    md: "3.1rem",
                                },
                            }}
                        >
                            Impulsamos tu crecimiento económico
                            <br />
                            con herramientas y servicios diseñados
                            <br />
                            para alcanzar tus metas
                        </Typography>
                    </Box>

                    {/* DERECHA */}
                    <Box
                        component={motion.div}
                        initial={{ opacity: 0, x: 80 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{
                            duration: 0.8,
                            delay: 0.2,
                        }}
                        sx={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <Box
                            component="img"
                            src={computadora}
                            alt="Servicios financieros"
                            sx={{
                                width: {
                                    xs: "90%",
                                    md: "600px",
                                },
                                maxWidth: "100%",
                            }}
                        />
                    </Box>
                </Box>
            </Container>

            {/* Flecha */}
            <Box
                component={motion.div}
                animate={{
                    y: [0, 10, 0],
                }}
                transition={{
                    duration: 1.5,
                    repeat: Infinity,
                }}
                sx={{
                    position: "absolute",
                    bottom: 35,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 60,
                    height: 60,
                    border: "2px solid #ffd700",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#ffd700",
                    fontSize: "2rem",
                    cursor: "pointer",
                }}
            >
                ↓
            </Box>
        </Box>
    );
};

export default Section1;